/**
 * GSAP ScrollTrigger setup and shared exports.
 *
 * LICENSING: GSAP "No Charge" license — scoped to public landing page only.
 * If GSAP is used inside the authenticated SaaS product, a Business license is required.
 * See: https://gsap.com/licensing/
 */
import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function useGSAP(callback, deps = []) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const ctx = gsap.context(() => {
      callback(gsap, containerRef.current);
    }, containerRef);

    return () => ctx.revert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return containerRef;
}

export { gsap, ScrollTrigger };
